import React, { useCallback } from 'react';
import Breadcrumb from 'Application/components/Header/Breadcrumb';
import useQueryParameter from 'Common/hooks/useQueryParameter';
import getEmployee from 'Employee/api/getEmployee';
import useAxiosRequest from 'Common/hooks/useAxiosRequest';

const LaravelBreadcrumbs = () => {
    const [employeeId] = useQueryParameter('emp');
    const [alternativeEmployeeId] = useQueryParameter('e');
    const [measureType] = useQueryParameter('t');

    const id = employeeId || alternativeEmployeeId;

    const employeeRequest = useCallback(
        cancelToken =>
            id ? getEmployee(id, [], cancelToken) : async () => null,
        [id],
    );

    const { data: employee, isLoading: isLoadingEmployee } = useAxiosRequest(
        employeeRequest,
        null,
    );

    if (isLoadingEmployee) {
        return null;
    }

    const path = window.location.pathname;

    if (path === '/backend/employees') {
        return <Breadcrumb isActive>Mitarbeiter</Breadcrumb>;
    }

    if (path === '/backend/m/exec/call') {
        if (employeeId && employee) {
            return (
                <>
                    <Breadcrumb href="/employees">Mitarbeiter</Breadcrumb>
                    <Breadcrumb
                        href={`/employee/${employee.id}`}
                    >{`${employee.firstName} ${employee.lastName}`}</Breadcrumb>
                    <Breadcrumb isActive>Ergänzende GF</Breadcrumb>
                </>
            );
        }

        return <Breadcrumb isActive>Ergänzende GF</Breadcrumb>;
    }

    if (path === '/backend/m/reminder/call') {
        return <Breadcrumb isActive>Maßnahmen</Breadcrumb>;
    }

    if (path === '/backend/m/reminder/content') {
        const breadcrumbs = [
            <Breadcrumb href="/measures">Maßnahmen</Breadcrumb>,
        ];

        // eslint-disable-next-line default-case
        switch (measureType) {
            case 'fire':
                breadcrumbs.push(<Breadcrumb isActive>Brandschutz</Breadcrumb>);
                break;

            case 'aid':
                breadcrumbs.push(<Breadcrumb isActive>Erste Hilfe</Breadcrumb>);
                break;

            case 'psa':
                breadcrumbs.push(
                    <Breadcrumb isActive>
                        Persönliche Schutzausrüstung
                    </Breadcrumb>,
                );
                break;

            case 'car':
                breadcrumbs.push(<Breadcrumb isActive>Fuhrpark</Breadcrumb>);
                break;

            case 'ladder':
                breadcrumbs.push(
                    <Breadcrumb isActive>
                        Prüfbedürftige Einrichtungen
                    </Breadcrumb>,
                );
                break;

            case 'eg':
                breadcrumbs.push(
                    <Breadcrumb isActive>Gefahrenstoffmanagement</Breadcrumb>,
                );
                break;

            case 'other':
                breadcrumbs.push(
                    <Breadcrumb isActive>Rechtsbelehrungen</Breadcrumb>,
                );
                break;
        }

        return breadcrumbs;
    }

    if (path === '/backend/m/docs/call') {
        return <Breadcrumb isActive>Dokumente</Breadcrumb>;
    }

    if (path === '/backend/m/csite/call') {
        return <Breadcrumb isActive>Ergänzende GF</Breadcrumb>;
    }

    if (path === '/backend/m/csite/report') {
        return (
            <>
                <Breadcrumb href="/backend/m/csite/call">
                    Ergänzende Gefährdungsbeurteilung
                </Breadcrumb>
                <Breadcrumb isActive>Bericht</Breadcrumb>
            </>
        );
    }

    if (path === '/backend/m/csite/detail') {
        return (
            <>
                <Breadcrumb href="/backend/m/csite/call">
                    Ergänzende Gefährdungsbeurteilung
                </Breadcrumb>
                <Breadcrumb isActive>Baustelle</Breadcrumb>
            </>
        );
    }

    if (path === '/backend/m/csite/create') {
        return (
            <>
                <Breadcrumb href="/backend/m/csite/call">
                    Ergänzende Gefährdungsbeurteilung
                </Breadcrumb>
                <Breadcrumb isActive>Baustelle anlegen</Breadcrumb>
            </>
        );
    }

    if (path === '/backend/m/csite/edit_template') {
        return (
            <>
                <Breadcrumb href="/backend/m/csite/call">
                    Ergänzende Gefährdungsbeurteilung
                </Breadcrumb>
                <Breadcrumb isActive>Vorlage anlegen</Breadcrumb>
            </>
        );
    }

    if (path === '/backend/m/dsgvo') {
        return <Breadcrumb isActive>EU-DSGVO</Breadcrumb>;
    }

    if (path === '/backend/m/archive/call') {
        return <Breadcrumb isActive>Archiv</Breadcrumb>;
    }

    if (path === '/backend/m/archive/employees') {
        return (
            <>
                <Breadcrumb href="/backend/m/archive/call">Archiv</Breadcrumb>
                <Breadcrumb isActive>Mitarbeiter</Breadcrumb>
            </>
        );
    }

    if (
        path === '/backend/m/archive/certificates' &&
        alternativeEmployeeId &&
        employee
    ) {
        return (
            <>
                <Breadcrumb href="/backend/m/archive/call">Archiv</Breadcrumb>
                <Breadcrumb href="backend/m/archive/employees">
                    Mitarbeiter
                </Breadcrumb>
                <Breadcrumb
                    isActive
                >{`${employee.firstName} ${employee.lastName}`}</Breadcrumb>
            </>
        );
    }

    return null;
};

export default LaravelBreadcrumbs;
